const env = process.env.VUE_APP_AMPLIFY_ENV;

export const CONST = {
  ENV: env,
  IS_DEV: ["dev", "devlite"].includes(env),
  IS_LITE: ["lite", "devlite"].includes(env),
};
